import { render, staticRenderFns } from "./NirAccomplishmentPage.vue?vue&type=template&id=3208895f&scoped=true"
import script from "./NirAccomplishmentPage.vue?vue&type=script&lang=js"
export * from "./NirAccomplishmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3208895f",
  null
  
)

export default component.exports